var _ = window._ = require('./underscore');

(function() {
	var Wrapper = this.Wrapper = function(el) {
		if (el) {
			this.el = el;
		}
	};

	var $ = this.$ = function(element) {
		if (typeof element === 'string') {
			return $.getById(element);
		}
		
		else {
			return new Wrapper(element);
		}
	};

	$.namespaces = {
		svg: 'http://www.w3.org/2000/svg',
		xlink: 'http://www.w3.org/1999/xlink',
	};

	$.element = function(element, ns) {
		if (ns) {
			return $(document.createElementNS($.namespaces[ns] || ns, element));
		}
		
		else {
			return $(document.createElement(element));
		}
	};

	$.div = function(id) {
		var div = $.element('div');
		
		if (id) {
			div.id(id);
		}
		
		return div;
	};

	$.getAllByClass = function(c) {
		return $(document.getElementsByClassName(c));
	};

	$.getByClass = function(c) {
		return $(document.querySelector(c));
	};

	$.getById = function(element) {
		return $(document.getElementById(element));
	};

	var $p = this.$p = Wrapper.prototype;

	$p.appendTo = function(element) {
		if (element.el) {
			element.el.appendChild(this.el);
		}
		
		else {
			element.appendChild(this.el);
		}
		
		return this;
	};

	$p.prependTo = function(element) {
		var parent = element;
		
		if (parent.el) {
			parent = parent.el;
		}
		
		parent.insertBefore(this.el, parent.firstChild);
		
		return this;
	};

	$p.after = function(element) {
		element.el.parentNode.insertBefore(this.el, element.el.nextSibling);
		
		return this;
	};

	$p.before = function(element) {
		element.el.parentNode.insertBefore(this.el, element.el);
		
		return this;
	};

	$p.reinsert = function() {
		if (!this.el.parentNode) {
			return this;
		}
		
		var parent = this.el.parentNode;
		var before = this.el.nextSibling;
		
		parent.removeChild(this.el);
		
		if (before) {
			parent.insertBefore(this.el, before);
		}
		
		else {
			parent.appendChild(this.el);
		}
		
		return this;
	};

	$p._addClass = function(c, el) {
		if (c.length === 1) {
			if (c[0].length) {
				el.classList.add(c[0]);
			}
		}
		
		else {
			_.each(c, function(v) {
				if (v.length) {
					el.classList.add(v);
				}
			});
		}
	};

	$p.addClass = function(c) {
		c = c.split(' ');
		
		$p._addClass(c, this.el);
		
		return this;
	};

	$p._removeClass = function(c, el) {
		if (c.length === 1) {
			if (c[0].length) {
				el.classList.remove(c[0]);
			}
		}
		
		else {
			_.each(c, function(v) {
				if (v.length) {
					el.classList.remove(v);
				}
			});
		}
	};

	$p.removeClass = function(c) {
		c = c.split(' ');
		
		$p._removeClass(c, this.el);
		
		return this;
	};

	$p._toggleClass = function(c, force, el) {
		// IE does not respect classList.toggle(..., force) paramater.
		if (c.length === 1) {
			if (c[0].length) {
				if (typeof force === 'boolean') {
					if (force) {
						el.classList.add(c[0]);
					}
					
					else {
						el.classList.remove(c[0]);
					}
				}
				
				else {
					el.classList.toggle(c[0]);
				}
			}
		}
		
		else {
			_.each(c, function(v) {
				if (v.length) {
					if (typeof force === 'boolean') {
						if (force) {
							el.classList.add(v);
						}
						
						else {
							el.classList.remove(v);
						}
					}
					
					else {
						el.classList.toggle(v);
					}
				}
			});
		}
	};

	$p.toggleClass = function(c, force) {
		c = c.split(' ');
		
		$p._toggleClass(c, force, this.el);
		
		return this;
	};

	$p.hasClass = function(c) {
		return this.el.classList.contains(c);
	};

	$p.id = function(id) {
		return this.attr('id', id);
	};
	
	var prefixed = [
		'transition',
		'transform',
	];
	
	$p.css = function(key, value) {
		if (typeof key === 'string') {
			var prefix = prefixed.reduce(function(prefix, property) {
				return prefix || key.indexOf(property) === 0;
			}, false);
			
			if (prefix) {
				this.css('-webkit-' + key, value);
			}
		}
		
		switch (true) {
			case _.isObject(key):
				_.each(key, function(v, k) {
					this.css(k, v);
				}, this);
				break;
			
			case _.isUndefined(value):
				return window.getComputedStyle(this.el, null).getPropertyValue(key);
			
			case _.isNull(value):
				this.el.style.removeProperty(key);
				break;
			
			case _.isNumber(value):
				this.el.style[key] = value.toString() + 'px';
				break;
			
			default:
				this.el.style[key] = value;
				break;
		}
		
		return this;
	};

	$p.attr = function(key, value, ns) {
		switch (true) {
			case _.isObject(key):
				_.each(key, function(v, k) {
					this.attr(k, v, ns);
				}, this);
				break;
			
			case _.isUndefined(value):
				return this.el.getAttribute(key);
			
			case _.isNull(value):
				this.el.removeAttribute(key);
				break;
			
			default:
				if (ns) {
					this.el.setAttributeNS($.namespaces[ns] || ns, key, value);
				}
				
				else {
					this.el.setAttribute(key, value);
				}
				
				break;
		}
		
		return this;
	};

	$p.html = function(html, append) {
		switch (true) {
			case _.isUndefined(html):
				return this.el.innerHTML;
			
			case _.isNull(html):
				this.el.innerHTML = '';
				break;
			
			default:
				if (append) {
					this.el.innerHTML += html;
				}
				
				else {
					this.el.innerHTML = html;
				}
				
				break;
		}
		
		return this;
	};

	$p.empty = function() {
		if (this.el.hasChildNodes()) {
			while (this.el.childNodes.length >= 1) {
				this.el.removeChild(this.el.firstChild);
			}
		}
		
		return this;
	};

	$p.index = function() {
		return Array.prototype.indexOf.call(this.el.parentNode.childNodes, this.el);
	};

	$p.child = function(index) {
		if (!this.el.childNodes.item(index)) {
			return null;
		}
		
		return $(this.el.childNodes.item(index));
	};

	$p.children = function() {
		return $(this.el.childNodes);
	};

	$p.first = function() {
		return $(this.el.firstChild);
	};

	$p.last = function() {
		return $(this.el.lastChild);
	};

	$p.remove = function() {
		if (!this.el.parentNode) {
			return this;
		}
		
		this.el.parentNode.removeChild(this.el);
		
		return this;
	};

	$p.clone = function(deep) {
		return $(this.el.cloneNode(deep));
	};

	$p.redraw = function() {
		return this.el.offsetHeight;
	};

	$.events = {};

	$p.on = function(event, check, fn, stop) {
		if (typeof check === 'function') {
			stop = fn;
			fn = check;
			check = undefined;
		}
		
		var callback = function(e) {
			var self = this;
			
			if (check) {
				self = $(e.target);
				
				if (!self.hasClass(check)) {
					return;
				}
			}
			
			fn.call(self, e);
			
			if (stop) {
				e.preventDefault();
				e.stopImmediatePropagation();
			}
		};
		
		if (typeof $.events[event] === 'string') {
			event = $.events[event];
		}
		
		if (typeof $.events[event] === 'function') {
			$.events[event].call(this, callback.bind(this));
		}
		
		else {
			this.el.addEventListener(event, callback.bind(this));
		}
		
		return this;
	};

	$p.trigger = $p.emit = function(event, data) {
		if (typeof $.events[event] === 'string') {
			event = $.events[event];
		}
		
		if (event === 'click') {
			if (document.createEvent) {
				var obj = document.createEvent('MouseEvents');
				obj.initEvent(event, true, false);
				
				for (var i in data) {
					obj[i] = data[i];
				}
				
				this.el.dispatchEvent(obj);
			}
			
			else if (document.createEventObject) {
				var obj = document.createEventObject();
				
				for (var j in data) {
					obj[j] = data[j];
				}
				
				this.el.fireEvent('on' + event, obj);
			}
			
			return this;
		}
		
		if (document.createEvent) {
			var obj = document.createEvent('CustomEvent');
			obj.initCustomEvent(event, true, false, data);
			this.el.dispatchEvent(obj);
		}
		
		else {
			this.el.dispatchEvent(new CustomEvent(event, { detail: data }));
		}
		
		return this;
	};

	$.events.click = function(callback) {
		var state = {
			touch: false,
		};
		
		this.el.addEventListener('click', function(e) {
			if (!state.touch || e.touch) {
				e.touch = e.touch || false;
				return callback(e);
			}
		});
		
		this.el.addEventListener('touchstart', function(e) {
			state.touch = true;
			state.dt = Date.now();
			
			state.x = e.touches[0].clientX;
			state.y = e.touches[0].clientY;
		});
		
		this.el.addEventListener('touchend', function(e) {
			var dx = e.changedTouches[0].clientX - state.x;
			var dy = e.changedTouches[0].clientY - state.y;
			var d = Math.sqrt(dx * dx + dy * dy);
			
			state.dt = Date.now() - state.dt;
			state.x = e.changedTouches[0].clientX;
			state.y = e.changedTouches[0].clientY;
			
			if (state.dt < 750 && d < 25) {
				$(e.target).trigger('click', {
					touchX: state.x,
					touchY: state.y,
					dx: dx,
					dy: dy,
					touch: true,
				});
				
				e.preventDefault();
				e.stopImmediatePropagation();
			}
		});
	};

	var div = document.createElement('div');

	if ('WebkitTransition' in div.style) {
		$.events.animationstart     = 'webkitAnimationStart';
		$.events.animationiteration = 'webkitAnimationIteration';
		$.events.animationend       = 'webkitAnimationEnd';
		
		$.events.transitionstart     = 'webkitTransitionStart';
		$.events.transitionend       = 'webkitTransitionEnd';
	}

	$.plugins = {};

	$p.apply = function(plugin, config) {
		if (!$.plugins[plugin]) {
			return this;
		}
		
		_.each($.plugins[plugin], function(value, key) {
			if (key.substr(0, 2) === '__') {
				return;
			}
			
			if (this[key]) {
				return;
			}
			
			this[key] = value;
		}, this);
		
		if ($.plugins[plugin].__init) {
			$.plugins[plugin].__init.call(this, config);
		}
		
		return this;
	};

	/* global alert */

	var DomReady = {
		isReady: false,
		readyList: [],
	};

	function domReady() {
		if (!DomReady.isReady) {
			DomReady.isReady = true;
			
			if (DomReady.readyList) {
				for (var fn = 0; fn < DomReady.readyList.length; fn++) {
					DomReady.readyList[fn].call();
				}
				
				DomReady.readyList = [];
			}
		}
	}

	DomReady.ready = function(fn, args) {
		if (DomReady.isReady) {
			fn.call(window, args);
		}
		
		else {
			DomReady.readyList.push(fn.bind(window, args));
		}
	};

	document.addEventListener('DOMContentLoaded', domReady, false);

	$.ready = DomReady.ready;

	$p.getBaseRect = function() {
		var rect = {};
		
		var rules = window.getMatchedCSSRules(this.el) || [];
		
		for (var i = 0; i < rules.length; i++) {
			if (rules[i].style.width) {
				rect.width = rules[i].style.width;
			}
			
			if (rules[i].style.height) {
				rect.height = rules[i].style.height;
			}
		}
		
		for (var i in rect) {
			if (rect[i].substr(-2) === 'px') {
				rect[i] = +rect[i].substr(0, rect[i].length - 2);
			}
		}
		
		return rect;
	};

	$.resize = function(game) {
		var parent = $(game.el.parentNode);
		
		document.addEventListener('touchmove', function(e) {
			e.preventDefault();
		});
		
		var resize = function() {
			parent.addClass('reset');
			
			window.scrollTo(0, 0);
			
			var dimensions = game.getBaseRect();
			
			var event = {
				scaleW: window.innerWidth / dimensions.width,
				scaleH: window.innerHeight / dimensions.height,
			};
			
			event.scale = Math.min(event.scaleW, event.scaleH);
			
			var notify = game.emit || game.trigger;
			notify.call(game, 'scale', event);
			
			game.css({
				'transform': 'scale(' + event.scale + ')',
				'width': window.innerWidth / event.scale,
				'height': window.innerHeight / event.scale,
			});
			
			parent.removeClass('reset');
		};
		
		window.addEventListener('resize', resize);
		document.addEventListener('resize', resize);
		
		setTimeout(resize, 100);
	};

	$.preload = function(items) {
		for (var i = 0; i < items.length; i++) {
			$.preload.total++;
			var image = new Image();
			image.onload = image.onerror = $.preload.done;
			image.src = items[i];
		}
	};

	$.preload.total = 0;
	$.preload.loaded = 0;
	$.preload.callback = null;

	$.preload.done = function() {
		$.preload.loaded++;
		$.preload.check();
	};

	$.preload.check = function() {
		if (this.loaded === this.total) {
			if (this.callback) {
				this.callback.call(null, this.total);
			}
		}
	};
}).call(window);



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/common/utilidom/utilidom.js
 **/